import { useLocation, useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { pagesWithoutHeaderSelector } from 'redux/selectors/config';
import { MainContainer, Scrollable } from './MainContainerStyled';
import { useEffect, useRef, useState } from 'react';
import { isTakingScreenshotSelector } from 'redux/selectors/picture';

export const mainContainerId = 'main-container';

export const MainContentContainer = ({ children }) => {
  const [realHeight, setRealHeight] = useState('0px');
  const pagesWithoutHeader = useSelector(pagesWithoutHeaderSelector);
  const isTakingScreenshot = useSelector(isTakingScreenshotSelector);
  const shouldDisplayHeader = !useRouteMatch({
    path: pagesWithoutHeader,
    exact: true,
  });
  const { pathname } = useLocation();
  const scrollableRef = useRef();
  useEffect(() => {
    scrollableRef.current?.scrollTo(0, 0);
  }, [pathname, scrollableRef]);

  const handleWindowSizeChange = () => {
    let value = '100vh';
    if (window.innerWidth <= 1024) {
      value = `${window.innerHeight}px`;
    }
    setRealHeight(value);
  };

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    handleWindowSizeChange();
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);
  return (
    <MainContainer
      shouldDisplayHeader={shouldDisplayHeader}
      isTakingScreenshot={isTakingScreenshot}
      realHeight={realHeight}
      data-testid={mainContainerId}
    >
      <Scrollable ref={scrollableRef}>{children}</Scrollable>
    </MainContainer>
  );
};
